export default "__VITE_ASSET__bc3db3c5__"